export default __webpack_public_path__ + "static/media/gallary9.54509082.jpg";